/**
 * What a reference degrades to when it appears INSIDE another reference's
 * label — see `creferenceDepth.tsx` for why the depth is bounded.
 *
 * It still resolves: the reader sees the entity's real name, not a raw
 * `[[p3]]` token. What it drops is the chip affordance (icon, hover, click)
 * and the markdown pass, which is what terminates the recursion.
 */

"use client";

import type { CSSProperties, ReactNode } from "react";

// Typography is inherited wholesale so the nested name reads as part of the
// label it sits in, rather than as a second styled element inside the chip.
const NESTED_LABEL_STYLE: CSSProperties = {
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  color: "inherit",
};

export interface CreferenceNestedLabelProps {
  className?: string;
  label: string;
  style?: CSSProperties;
}

export function CreferenceNestedLabel({
  className,
  label,
  style,
}: CreferenceNestedLabelProps): ReactNode {
  return (
    <span className={className} style={{ ...NESTED_LABEL_STYLE, ...style }}>
      {label}
    </span>
  );
}
